import React, { Fragment, useEffect, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { NavLink } from "react-router-dom";
import axios from 'axios';
import './style.css';
import HeaderTopbar from '../HeaderTopbar/HeaderTopbar';

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/'
    },
    {
        id: 2,
        title: 'About us',
        link: '/about',
        submenu: [
            { id: 61, title: 'About', link: '/about' },
            { id: 62, title: 'Team', link: '/team' },
            { id: 63, title: 'Our Business', link: '/business' }
        ]
    },
    {
        id: 6,
        title: 'Service',
        link: '/service'
    },
    {
        id: 3,
        title: 'Products',
        link: '/product',
        // categories will be dynamically added here
    },
    {
        id: 7,
        title: 'Projects',
        link: '/project'
    },
    {
        id: 5,
        title: 'Events',
        link: '/event'
    },
    {
        id: 88,
        title: 'Contact',
        link: '/contact'
    }
];

const MobileMenu = () => {
    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);
    const [categories, setCategories] = useState([]);
    const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;

    const ClickHandler = () => {
        window.scrollTo(10, 0);
        setMenuState(false);
    };

    // Fetch categories (same logic as Header2)
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res = await axios.get(`${apiUrl}/api/pro-categ-name`, {
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                    },
                });
                setCategories(res.data);
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };
        fetchCategories();
    }, [apiUrl]);

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}>
                        <i className="ti-close"></i>
                    </div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
                        // Handle "Products" menu specially — inject categories
                        if (item.title === "Products") {
                            return (
                                <ListItem
                                    className={item.id === openId ? 'active' : null}
                                    key={mn}
                                >
                                    <Fragment>
                                        <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>
                                            {item.title}
                                            <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                        </p>
                                        <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                            <List className="subMenu">
                                                <ListItem>
                                                    <NavLink onClick={ClickHandler} to="/product">
                                                        All Products
                                                    </NavLink>
                                                </ListItem>
                                                {categories.length > 0 ? (
                                                    categories.map((c, index) => (
                                                        <ListItem key={index}>
                                                            <NavLink
                                                                onClick={ClickHandler}
                                                                to={`/product?category_id=${c.id}&category_name=${encodeURIComponent(c.name)}`}
                                                            >
                                                                {c.name}
                                                            </NavLink>
                                                        </ListItem>
                                                    ))
                                                ) : (
                                                    <ListItem>
                                                        <span style={{ paddingLeft: '15px', fontSize: '14px', color: '#999' }}>
                                                            Loading...
                                                        </span>
                                                    </ListItem>
                                                )}
                                            </List>
                                        </Collapse>
                                    </Fragment>
                                </ListItem>
                            );
                        }

                        // Handle all other menus normally
                        return (
                            <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                                {item.submenu ? (
                                    <Fragment>
                                        <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>
                                            {item.title}
                                            <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                        </p>
                                        <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                            <List className="subMenu">
                                                {item.submenu.map((submenu, i) => (
                                                    <ListItem key={i}>
                                                        <NavLink onClick={ClickHandler} to={submenu.link}>
                                                            {submenu.title}
                                                        </NavLink>
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </Collapse>
                                    </Fragment>
                                ) : (
                                    <NavLink onClick={ClickHandler} to={item.link}>
                                        {item.title}
                                    </NavLink>
                                )}
                            </ListItem>
                        );
                    })}
                </ul>
                <div className="mobile-topbar">
                    <HeaderTopbar mobile={true}/>
                </div>
            </div>

            <div className="showmenu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    );
};

export default MobileMenu;
